import { EntityHandler, EntityListResult, SectionHandlerGroup, FormSectionHandler } from '../entity.handler';
import { IKuiTableCol } from 'app/key-ui';
import { Injectable } from '@angular/core';
import { MapSetResponse, MapsetCreateRequest } from '@key-telematics/fleet-api-client';
import { AdminEditorService } from '../../admin.service';
import { GridColumnHelper, EnumToComboValues } from '../utils';
import { ICONS } from '../icons';
import { MapSetDetailsSectionHandler } from './details.section';
import { RegisterEntityHandler } from '../../entities';

@RegisterEntityHandler('mapset')
@Injectable()
export class MapSetHandler extends EntityHandler<MapSetResponse> {

    constructor(
        admin: AdminEditorService
    ) {
        super(admin);
    }

    states = ['active', 'deleted'];
    entityDefaults: MapSetResponse;

    listEntities(ownerId: string, offset: number, limit: number, sort: string, filter: string): Promise<EntityListResult> {
        return this.admin.getCached(`listMapSets/${ownerId}/${offset}/${limit}/${sort}/${filter}`, api => api.entities.listMapSets(ownerId, offset, limit, sort, filter), 3).then(response => ({
            ...response,
            type: 'mapset',
            title: this.admin.i18n.instant('ADMIN.ENTITIES.MAPSETS'),
        }));
    }

    getEntity(id: string): Promise<MapSetResponse> {
        return this.admin.getCached(`getMapSet/${id}`, api => api.entities.getMapSet(id), 10);
    }

    createEntity(ownerId: string, entity: MapsetCreateRequest): Promise<MapSetResponse> {
        entity.ownerId = ownerId;
        return this.admin.applyUpdate(api => api.entities.createMapSet(entity));
    }

    setEntityState(entity: any, state: string): Promise<any> {
        return this.admin.applyUpdate(api => api.entities.updateMapSet(entity.id, { state: state as any }));
    }

    getGridColumns(_ownerId: string): Promise<IKuiTableCol[]> {
        const grid = new GridColumnHelper(this.admin.i18n, 'ADMIN.EDITORS.MAPSET.COLUMNS');
        const columns: IKuiTableCol[] = [
            grid.IconTextColumn('name', 'NAME', (row) => {
                return row.folder ? ICONS.folder : ICONS.mapset;
            }),
            grid.ComboColumn('state', 'STATE', EnumToComboValues(this.admin.i18n, 'ADMIN.STATES', this.states, ['deleted']), 80),
        ];
        return Promise.resolve(columns);
    }

    getEditorSections(ownerId: string, _entity: MapSetResponse): Promise<SectionHandlerGroup<MapSetResponse>[]> {
        return Promise.resolve([{
            name: this.admin.i18n.instant('ADMIN.EDITOR.INFORMATION'),
            sections: [
                new MapSetDetailsSectionHandler(this.admin, ownerId, false, this),
            ],
        }]);
    }

    getCreationSections(ownerId: string): Promise<{ entityType: string, entity: any, sections: FormSectionHandler<MapSetResponse, any>[] }> {
        return Promise.resolve({
            entityType: 'mapset',
            entity: this.entityDefaults || {},
            sections: [
                new MapSetDetailsSectionHandler(this.admin, ownerId, true, this),
            ],
        });
    }

}













